// import React, { useRef, useState, useEffect } from "react";
// import { connect } from "react-redux";
// import UserLayout from "./UserLayout";
// import { useForm } from "react-hook-form";
// import { changePasswordAction } from "../../../redux/actions/user/userAction";
// import axiosInstance from "../../authentication/helper/axiosApi";
// import { error } from "jquery";
// import { Button } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";

// export const SubscriptionPlan = (props) => {
//   console.log(props.user.is_paid);

//   const navigate = useNavigate();

//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleNavigate = () => {
//     navigate("/user/profile-analytics");
//   };

//   return (
//     <UserLayout>
//       {props.user && props.user.is_paid ? (
//         <div className="right-section">
//           <div className="row align-items-end mb-65">
//             <div className="col-sm-12 col-12">
//               {/* <h2 className="page-title">
//                 <>MY</>
//                 <br></br>
//                 <strong>Subscription</strong>
//               </h2> */}
//                         <div className="banner">
//               <div className="banner-title-overlay">
//                 <h5 style={ isMobile ? { marginLeft: "-10px"} : {}}>
//                   <span>
//                     MY
//                     <br />
//                     <b>Subscription</b>
//                     <hr
//                       style={{
//                         display: isMobile ? "none" : "block",
//                         height: "5px",
//                         background: "white",
//                         width: "75%",
//                       }}
//                     />
//                   </span>
//                 </h5>
//                 <img
//                   src="\assets\images\icons\myAccountIcon.png"
//                   className="icon-image "
//                 />
//               </div>

//               <img
//                 className="banner-image"
//                 src="\assets\images\Asset 1.png"
//                 alt="Not Found"
//               />
//             </div>
//             </div>
//           </div>
//           <div className="row margin-row">
//             <div className="col-12 card-block">
//               <div className="card-border">
//                 <div className="row">
//                   <div className="col cmb-25">
//                     <h3>Subscription Status</h3>
//                   </div>
//                 </div>
//                 <div className="row">
//                   <div className="col-md-6 col-12">
//                     <label className="field-label">Plan </label>
//                   </div>
//                   <div className="input-group table-group col-md-5 col-10">
//                     <span className="text">
//                       {" "}
//                       <strong>goneet</strong>&nbsp;
//                       <label
//                         style={{
//                           backgroundColor: "#283270",
//                           color: "white",
//                           padding: "4px",
//                           borderRadius: "5px",
//                         }}
//                       >
//                         PRO
//                       </label>
//                     </span>
//                   </div>
//                 </div>
//                 <br></br>
//                 <div className="row ">
//                   <div className="col-md-6 col-12">
//                     <label className="field-label">Activation Date</label>
//                   </div>
//                   <div className="input-group table-group col-md-5 col-10">
//                     <label>10/09/2023</label>
//                   </div>
//                 </div>
//                 <br></br>
//                 <div className="row ">
//                   <div className="col-md-6 col-12">
//                     <label className="field-label">Expiration Date</label>
//                   </div>
//                   <div className="input-group table-group col-md-5 col-10">
//                     <div className="input-group-append">
//                       <label>10/12/2023</label>
//                     </div>
//                   </div>
//                 </div>
//                 <br></br>
//               </div>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="right-section">
//           <div className="row align-items-end mb-65">
//             <div className="col-sm-12 col-12">
//               {/* <h2 className="page-title">
//                 <>MY</>
//                 <br></br>
//                 <strong>Subscription</strong>
//               </h2> */}
//                         <div className="banner">
//               <div className="banner-title-overlay">
//                 <h5>
//                   <span>
//                     MY
//                     <br />
//                     <b>Subscription</b>
//                     <hr
//                       style={{
//                         height: "5px",
//                         background: "white",
//                         width: "75%",
//                       }}
//                     />
//                   </span>
//                 </h5>
//                 <img
//                   src="\assets\images\icons\myAccountIcon.png"
//                   className="icon-image "
//                 />
//               </div>

//               <img
//                 className="banner-image"
//                 src="\assets\images\Asset 1.png"
//                 alt="Not Found"
//               />
//             </div>
//             </div>
//           </div>
//           <div className="row margin-row">
//             <div className="col-12 card-block">
//               <div className="card-border">
//                 <div className="row">
//                   <div className="col cmb-25 mb-5">
//                     <h3>Subscription Status</h3>
//                   </div>
//                 </div>
//                 <div className="text-center">
//                   Get Your Plan Today <br />
//                   <Button
//                     style={{ background: "#283270" }}
//                     onClick={handleNavigate}
//                   >
//                     Join
//                   </Button>
//                 </div>
//                 <br />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </UserLayout>
//   );
// };

// const mapStateToProps = (state) => {
//   const user = state.user.user;

//   return {
//     user: user,
//     user: user,
//   };
// };
// const mapDispatchToProps = (dispatch) => {
//   return {
//     changePassword: (data, id) => dispatch(changePasswordAction(data, id)),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlan);



//////////////api //////////////////////////

import React, { useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import UserLayout from "./UserLayout";
import { useForm } from "react-hook-form";
import { changePasswordAction } from "../../../redux/actions/user/userAction";
import axiosInstance from "../../authentication/helper/axiosApi";
import { error } from "jquery";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export const SubscriptionPlan = (props) => {
  console.log(props.user.is_paid);

  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavigate = () => {
    navigate("/user/profile-analytics");
  };

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      if (!props.user?.id || !props.user?.is_paid) return;

      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/api/payments/payment_view/${props.user.id}/`
        );
        setPaymentDetails(response.data);
      } catch (err) {
        console.error("Failed to fetch payment details", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, [props.user]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-GB");
  };



  return (
    <UserLayout>
      {props.user && props.user.is_paid ? (
        <div className="right-section">
          <div className="row align-items-end mb-65">
            <div className="col-sm-12 col-12">
              {/* <h2 className="page-title">
                <>MY</>
                <br></br>
                <strong>Subscription</strong>
              </h2> */}
                        <div className="banner">
              <div className="banner-title-overlay">
                <h5 style={ isMobile ? { marginLeft: "-10px"} : {}}>
                  <span>
                    MY
                    <br />
                    <b>Subscription</b>
                    <hr
                      style={{
                        display: isMobile ? "none" : "block",
                        height: "5px",
                        background: "white",
                        width: "75%",
                      }}
                    />
                  </span>
                </h5>
                <img
                  src="\assets\images\icons\myAccountIcon.png"
                  className="icon-image "
                />
              </div>

              <img
                className="banner-image"
                src="\assets\images\Asset 1.png"
                alt="Not Found"
              />
            </div>
            </div>
          </div>
          <div className="row margin-row">
            <div className="col-12 card-block">
              <div className="card-border">
                <div className="row">
                  <div className="col cmb-25">
                    <h3>Subscription Status</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <label className="field-label">Plan </label>
                  </div>
                  <div className="input-group table-group col-md-5 col-10">
                    <span className="text">
                      {" "}
                      <strong>goneet</strong>&nbsp;
                      <label
                        style={{
                          backgroundColor: "#283270",
                          color: "white",
                          padding: "4px",
                          borderRadius: "5px",
                        }}
                      >
                        PRO
                      </label>
                    </span>
                  </div>
                </div>
                <br></br>
                <div className="row ">
                  <div className="col-md-6 col-12">
                    <label className="field-label">Activation Date</label>
                  </div>
                  <div className="input-group table-group col-md-5 col-10">
                    <label>
                      {loading ? "Loading..." : formatDate(paymentDetails?.activation_date)}
                    </label>

                  </div>
                </div>
                <br></br>
                <div className="row ">
                  <div className="col-md-6 col-12">
                    <label className="field-label">Expiration Date</label>
                  </div>
                  <div className="input-group table-group col-md-5 col-10">
                    <div className="input-group-append">
                      <label>
                        {loading ? "Loading..." : formatDate(paymentDetails?.expiry_date)}
                      </label>

                    </div>
                  </div>
                </div>
                <br></br>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="right-section">
          <div className="row align-items-end mb-65">
            <div className="col-sm-12 col-12">
              {/* <h2 className="page-title">
                <>MY</>
                <br></br>
                <strong>Subscription</strong>
              </h2> */}
                        <div className="banner">
              <div className="banner-title-overlay">
                <h5>
                  <span>
                    MY
                    <br />
                    <b>Subscription</b>
                    <hr
                      style={{
                        height: "5px",
                        background: "white",
                        width: "75%",
                      }}
                    />
                  </span>
                </h5>
                <img
                  src="\assets\images\icons\myAccountIcon.png"
                  className="icon-image "
                />
              </div>

              <img
                className="banner-image"
                src="\assets\images\Asset 1.png"
                alt="Not Found"
              />
            </div>
            </div>
          </div>
          <div className="row margin-row">
            <div className="col-12 card-block">
              <div className="card-border">
                <div className="row">
                  <div className="col cmb-25 mb-5">
                    <h3>Subscription Status</h3>
                  </div>
                </div>
                <div className="text-center">
                  Get Your Plan Today <br />
                  <Button
                    style={{ background: "#283270" }}
                    onClick={handleNavigate}
                  >
                    Join
                  </Button>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      )}
    </UserLayout>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;

  return {
    user: user,
    user: user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changePassword: (data, id) => dispatch(changePasswordAction(data, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPlan);
